import { render } from "./NewReferral.vue?vue&type=template&id=301b5e0f"
import script from "./NewReferral.vue?vue&type=script&lang=js"
export * from "./NewReferral.vue?vue&type=script&lang=js"

import "./NewReferral.vue?vue&type=style&index=0&id=301b5e0f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__